const getNavigatorUserAgent = () => {
  if (typeof window === 'undefined' || !window.navigator) {
    return '';
  }
  return window.navigator.userAgent || '';
};

export const isMobileSafari = () => {
  if (!window) {
    return false;
  }

  // https://stackoverflow.com/a/29696509
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);

  // If iOS Chrome needs to be separated, use `!ua.match(/CriOS/i)` as
  // an extra condition.
  return iOS && webkit;
};

/**
 * Historical detection used by the login page before the auth-clarity flag.
 * Kept unchanged so flag-off Google/Facebook clicks still only intercept
 * Instagram / Facebook / Messenger webviews.
 */
export const isEmbeddedWebView = userAgent => {
  const ua = userAgent || getNavigatorUserAgent();
  if (!ua) {
    return false;
  }
  return /instagram|FBAN|FBAV/i.test(ua);
};

const WEBVIEW_APP_PATTERNS = [
  { app: 'instagram', test: /Instagram/i },
  { app: 'messenger', test: /Messenger|FB_IAB\/Orca|\[FBAN\/Messenger/i },
  { app: 'facebook', test: /FBAN|FBAV|FB_IAB/i },
  { app: 'snapchat', test: /Snapchat/i },
  { app: 'tiktok', test: /BytedanceWebview|TikTok|musical_ly/i },
  { app: 'line', test: /Line\//i },
  { app: 'linkedin', test: /LinkedInApp/i },
  { app: 'twitter', test: /Twitter/i },
  { app: 'telegram', test: /Telegram/i },
  { app: 'whatsapp', test: /WhatsApp/i },
];

const detectOs = ua => {
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'ios';
  }
  if (/Android/i.test(ua)) {
    return 'android';
  }
  return 'other';
};

/**
 * Broader in-app browser detection for the flagged handoff + analytics.
 * `app` is a stable short name, or null when this is not a known webview.
 */
export const detectEmbeddedWebView = userAgent => {
  const ua = userAgent || getNavigatorUserAgent();
  const os = detectOs(ua);

  if (!ua) {
    return { isWebView: false, app: null, os };
  }

  const matched = WEBVIEW_APP_PATTERNS.find(({ test }) => test.test(ua));
  if (matched) {
    return { isWebView: true, app: matched.app, os };
  }

  // Generic Android WebView: "Mozilla/5.0 (Linux; Android …; wv) AppleWebKit/…"
  if (/; wv\)/i.test(ua)) {
    return { isWebView: true, app: 'android_webview', os };
  }

  return { isWebView: false, app: null, os };
};

export const getWebviewAppName = userAgent => detectEmbeddedWebView(userAgent).app || 'none';
